document.addEventListener("DOMContentLoaded", function () {

    /*
    |--------------------------------------------------------------------------
    | Configuration
    |--------------------------------------------------------------------------
    */

    const API_URL =
        "https://dialog.modish.no/api/top-campaign-banner-attributes";

    const BANNER_ID =
        "top-campaign-banner";

    const storeNameElement =
        document.getElementById("store_name");

    const themeSettings =
        window.ModishTopCampaignBannerSettings || {};

    let bannerData = null;
    let lastContainer = null;


    /*
    |--------------------------------------------------------------------------
    | Store Name
    |--------------------------------------------------------------------------
    */

    if (!storeNameElement) {
        console.error(
            "Modish Top Campaign Banner: #store_name not found."
        );

        return;
    }

    const storeName =
        storeNameElement.value?.trim();

    if (!storeName) {
        console.error(
            "Modish Top Campaign Banner: store name is empty."
        );

        return;
    }


    /*
    |--------------------------------------------------------------------------
    | Hide Banner
    |--------------------------------------------------------------------------
    */

    function hideBanner() {

        const container =
            document.getElementById(BANNER_ID);

        if (!container) {
            return;
        }

        container.replaceChildren();
        container.style.display = "none";
    }


    /*
    |--------------------------------------------------------------------------
    | Validate / Normalize URL
    |--------------------------------------------------------------------------
    |
    | Allows:
    |
    | https://example.com
    | http://example.com
    | /collections/sale
    | /pages/member
    |
    | Rejects unsafe URLs such as javascript:
    |--------------------------------------------------------------------------
    */

    function getSafeUrl(rawUrl) {

        if (
            typeof rawUrl !== "string" ||
            !rawUrl.trim()
        ) {
            return null;
        }

        const url =
            rawUrl.trim();


        /*
         * Relative Shopify URL
         */
        if (
            url.startsWith("/") ||
            url.startsWith("#")
        ) {
            return url;
        }


        try {

            const parsed =
                new URL(
                    url,
                    window.location.origin
                );


            if (
                parsed.protocol === "https:" ||
                parsed.protocol === "http:"
            ) {
                return parsed.href;
            }

        } catch (error) {

            console.error(
                "Modish Top Campaign Banner: invalid URL:",
                url
            );
        }


        return null;
    }


    /*
    |--------------------------------------------------------------------------
    | Get Banner Data
    |--------------------------------------------------------------------------
    */

    async function getBannerData() {

        /*
         * Disabled from Shopify Theme Editor
         */
        if (themeSettings.enabled === false) {
            return null;
        }


        /*
         * ==========================
         * SOURCE: SHOPIFY
         * ==========================
         */

        if (themeSettings.source === "shopify") {

            return {
                status: 1,

                text:
                    themeSettings.text || "",

                url:
                    themeSettings.url || null,

                banner_background_color:
                    themeSettings.backgroundColor ||
                    "#d6959b",

                text_color:
                    themeSettings.textColor ||
                    "#ffffff"
            };
        }


        /*
         * ==========================
         * SOURCE: MODISH
         * ==========================
         */

        try {

            const response =
                await fetch(
                    API_URL,
                    {
                        method: "POST",

                        headers: {
                            "Content-Type":
                                "application/json"
                        },

                        body: JSON.stringify({
                            store_name: storeName
                        })
                    }
                );


            if (!response.ok) {

                console.error(
                    "Modish Top Campaign Banner API error:",
                    response.status
                );

                return null;
            }


            const data =
                await response.json();


            console.log(
                "Modish Top Campaign Banner:",
                data
            );


            return data;

        } catch (error) {

            console.error(
                "Modish Top Campaign Banner request failed:",
                error
            );

            return null;
        }
    }


    /*
    |--------------------------------------------------------------------------
    | Render Banner
    |--------------------------------------------------------------------------
    */

    function renderBanner() {

        const container =
            document.getElementById(BANNER_ID);


        /*
         * Cart drawer container not found
         */
        if (!container) {
            return;
        }


        /*
         * No banner data
         */
        if (!bannerData) {

            hideBanner();

            return;
        }


        /*
         * Modish status
         *
         * 1 = Active
         * 0 = Inactive
         */
        if (
            Number(bannerData.status) !== 1
        ) {

            hideBanner();

            return;
        }


        /*
         * Values
         */

        const text =
            bannerData.text || "";

        const url =
            getSafeUrl(
                bannerData.url
            );

        const backgroundColor =
            bannerData.banner_background_color ||
            "#d6959b";

        const textColor =
            bannerData.text_color ||
            "#ffffff";


        /*
         * Clear old content
         */
        container.replaceChildren();


        /*
        |--------------------------------------------------------------------------
        | URL EXISTS
        |--------------------------------------------------------------------------
        |
        | Make entire banner clickable.
        */

        if (url) {

            const link =
                document.createElement("a");


            link.href =
                url;

            link.textContent =
                text;


            /*
             * Make full banner clickable
             */
            link.style.display =
                "block";

            link.style.width =
                "100%";

            link.style.boxSizing =
                "border-box";

            link.style.padding =
                "14px 20px";

            link.style.color =
                "inherit";

            link.style.textDecoration =
                "none";

            link.style.cursor =
                "pointer";

            link.style.textAlign =
                "center";


            container.appendChild(
                link
            );


            /*
             * Padding belongs to link,
             * so the complete banner area
             * is clickable.
             */
            container.style.padding =
                "0";
        }


        /*
        |--------------------------------------------------------------------------
        | NO URL
        |--------------------------------------------------------------------------
        */

        else {

            container.textContent =
                text;

            container.style.padding =
                "14px 20px";
        }


        /*
        |--------------------------------------------------------------------------
        | Dynamic Colors
        |--------------------------------------------------------------------------
        */

        container.style.backgroundColor =
            backgroundColor;

        container.style.color =
            textColor;


        /*
        |--------------------------------------------------------------------------
        | Banner Styling
        |--------------------------------------------------------------------------
        */

        container.style.display =
            "block";

        container.style.boxSizing =
            "border-box";

        container.style.textAlign =
            "center";

        container.style.fontSize =
            "14px";

        container.style.fontWeight =
            "500";

        container.style.lineHeight =
            "1.4";

        container.style.marginBottom =
            "15px";
    }


    /*
    |--------------------------------------------------------------------------
    | Initialize
    |--------------------------------------------------------------------------
    */

    async function init() {

        /*
         * Disabled from Shopify
         */
        if (themeSettings.enabled === false) {

            hideBanner();

            return;
        }


        /*
         * Get data
         */
        bannerData =
            await getBannerData();


        if (!bannerData) {

            hideBanner();

            return;
        }


        /*
         * Initial render
         */
        renderBanner();


        /*
         * Remember current container
         */
        lastContainer =
            document.getElementById(
                BANNER_ID
            );
    }


    /*
    |--------------------------------------------------------------------------
    | Cart Drawer Observer
    |--------------------------------------------------------------------------
    |
    | Dawn can recreate the cart drawer after:
    |
    | - Add product
    | - Remove product
    | - Change quantity
    |
    | When a NEW #top-campaign-banner
    | element is created, render the
    | already-loaded bannerData again.
    |--------------------------------------------------------------------------
    */

    const observer =
        new MutationObserver(
            function () {

                const container =
                    document.getElementById(
                        BANNER_ID
                    );


                /*
                 * Container currently doesn't exist
                 */
                if (!container) {

                    lastContainer = null;

                    return;
                }


                /*
                 * Dawn recreated the container
                 */
                if (
                    container !== lastContainer &&
                    bannerData
                ) {

                    lastContainer =
                        container;

                    renderBanner();
                }
            }
        );


    observer.observe(
        document.body,
        {
            childList: true,
            subtree: true
        }
    );


    /*
    |--------------------------------------------------------------------------
    | Start
    |--------------------------------------------------------------------------
    */

    init();

});